export default __webpack_public_path__ + "static/horizontal-04bf8ee8ac7e328c186554800500b22c.png";